import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Project } from '../project'
import { ProjectService } from '../project.service'
import { RuntimeService } from '../runtime.service'

@Component({
  selector: 'app-project-summary',
  templateUrl: './project-summary.component.html',
  styleUrls: ['./project-summary.component.css']
})
export class ProjectSummaryComponent implements OnInit {
  project: Project
  exportTags = false


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projects: ProjectService,
    private rts: RuntimeService
  ) {
    this.rts.adminType = 'project'
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.project = this.projects.get(params['id'])
      this.rts.currentProject = this.project
      if (!this.project)
        return this.router.navigate(['projects'])
      this.project.initProject()
    })
  }

  tagsExportSwitch() {
    this.exportTags = !this.exportTags
  }

}



// WEBPACK FOOTER //
// ./src/app/project-summary/project-summary.component.ts